module.exports = __webpack_public_path__ + "img/racetrack-scottsville-turf-standside.98f177b7.svg";